import { HeaderNotification } from './HeaderNotification';

type Props = {
    hasSecondApplicant: boolean;
};

export const HeaderNotifications: React.FC<Props> = ({ hasSecondApplicant }) => {
    return (
        <div className="flex flex-wrap justify-end gap-2">
            <HeaderNotification isSecondApplicant={false} hasSecondApplicant={hasSecondApplicant} />
            {hasSecondApplicant && (
                <HeaderNotification isSecondApplicant={true} hasSecondApplicant={hasSecondApplicant} />
            )}
        </div>
    );
};
